export const COMMON_SETTINGS = {
  MARGIN: { left: 40, right: 40, top: 0, bottom: 30 },
  TEXT_SM_SIZE: 10,
  TEXT_MD_SIZE: 12,
};

export const ChartConfig = {
  Dark: {
    TEXT_COLOR: '#ffffff',
    CHART_INDEX: {
      COLOR: '#47c3ff',
    },
    CHART_RATE: {
      COLOR: '#facc5c',
    },
    COORDINATE_COLOR_1: 'rgba(87, 249, 214, 0.15)', // blue line
    COORDINATE_COLOR_2: 'rgba(255,200,89, 0.15)', // yellow line
    ...COMMON_SETTINGS,
  },
  Light: {
    TEXT_COLOR: '#1f2023',
    CHART_INDEX: {
      COLOR: '#2c73e8',
    },
    CHART_RATE: {
      COLOR: '#f8bc06',
    },
    COORDINATE_COLOR_1: 'rgba(44,115,232, 0.15)', // blue line
    COORDINATE_COLOR_2: 'rgba(255,200,89, 0.15)', // yellow line
    ...COMMON_SETTINGS,
  },
  Classic: {
    TEXT_COLOR: '#ffffff',
    CHART_INDEX: {
      COLOR: '#47c3ff',
    },
    CHART_RATE: {
      COLOR: '#facc5c',
    },
    COORDINATE_COLOR_1: 'rgba(87, 249, 214, 0.15)', // blue line
    COORDINATE_COLOR_2: 'rgba(255,200,89, 0.15)', // yellow line
    ...COMMON_SETTINGS,
  },
};
